import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=a12015fc&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"
import style0 from "./Index.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./Index.vue?vue&type=style&index=1&id=a12015fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12015fc",
  null
  
)

export default component.exports